import * as client from "../../../client";
import { TooltipWrapper } from "../../../components/tooltip/TooltipWrapper";
import { formatTwoDecimals } from "../utils";
import styles from "./InternationalExposureFlag.module.css";

type InternationalExposureFlagProps = {
  precomputedMetadata: client.PrecomputedMetadata;
};

/**
 * Red text flag noting that a submission has any international exposure at all
 * (TIV outside the 50 US states + DC). Renders nothing when the schedule is
 * entirely domestic, so callers can drop it into a row unconditionally.
 */
export const InternationalExposureFlag: React.FC<
  InternationalExposureFlagProps
> = ({ precomputedMetadata }) => {
  const pct = precomputedMetadata.foreign_exposure_pct;
  if (pct == null || pct <= 0) {
    return null;
  }
  return (
    <TooltipWrapper
      tooltipText={`${formatTwoDecimals(
        pct
      )}% of schedule TIV is international exposure (outside the 50 US states + DC).`}
      maxWidth={260}
    >
      <span className={styles.flag}>
        <i className="pi pi-exclamation-triangle" />
        International Exposure
      </span>
    </TooltipWrapper>
  );
};
